/*
 * Copyright (c) 2022-2024 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */
import { z } from 'zod'

export const UpdateUserTitleRequest = z.object({
  title: z.enum([
    'UNKNOWN',
    'PRODUCT_MANAGER',
    'PROJECT_MANAGER',
    'ACCOUNT_MANAGER',
    'DELIVERY_MANAGER',
    'SOLUTION_ARCHITECT',
    'ENGINEER',
    'LIVEOPS',
    'BUSINESS_DEVELOPMENT',
    'FINANCE',
    'EXECUTIVE_SPONSOR',
    'EXECUTIVE',
    'EMPLOYEE'
  ])
})

export interface UpdateUserTitleRequest extends z.TypeOf<typeof UpdateUserTitleRequest> {}
